export default __webpack_public_path__ + "static/media/equal-footer-banner-left.58f57d8e.png";